import { Link } from "gatsby";
import React, { useState } from "react";
import { RenderSvg } from "../../../../../utils/helpers/helper";
import * as BlogStyles from "../../../css/BlogDetails.module.css";
import { Popup } from "../../../../../components/popup";
import BlogInfo from "../../../blogs/details/components/BlogInfo";
import BackgroundWave from "../../../../../components/layoutSections/BackgroundWave";

export default function CaseStudyDetailsBanner({ caseStudy, styles }) {
  const { caseStudyName, pdf, subTitle } = caseStudy || {};
  const [openPopup, setOpenPopup] = useState(false);
  const [copied, setCopied] = useState(false);
  const { PdfFile } = pdf || {};
  const bgColor = "grey";

  return (
    <>
      {copied && <div className="showCopied"> Link Copied</div>}
      <div className={styles?.caseStudySingleContainer}>
        <BackgroundWave bgColor={bgColor} />
        <div className={styles?.caseStudySingleWrap}>
          <div>
            <Link to="/resources/casestudy">
              <span style={{ display: "flex" }}>
                <RenderSvg
                  IconName={"chevron-left"}
                  style={{
                    color: "#009bff",
                    height: "15px",
                  }}
                />
              </span>
              Back to case studies
            </Link>
          </div>
          <div>
            <h2 className="heading-tertiary-lg">{caseStudyName}</h2>
          </div>
          <div className={styles?.caseStudySingleBannerItems}>
            <BlogInfo
              blogTitle={caseStudyName}
              blog_category={{ categoryName: "case Study" }}
              styles={BlogStyles}
              readTime={caseStudy?.readTime || "5 min"}
              PdfFile={PdfFile}
              className={"mobile-hide"}
            />
          </div>
        </div>
      </div>
      <Popup openPopup={openPopup} setOpenPopup={setOpenPopup} share />
    </>
  );
}
